// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"81acc28d","167":"cc6903ac","311":"0c106351","318":"66d3e9ba","453":"2213f05c","514":"ab34a157","671":"dd7fc3af","950":"8cccb22e"}[chunkId] + ".chunk.js";
};